// Define program constants
export const LOGIN = 'login'
export const REGISTER = 'register'
export const FORGET_PASSWORD = 'forgetPassword'
export const CHANGE_PASSWORD = 'changePassword'
export const CAR_DETAILS = 'carDetails'
export const CHANGE_PASSWORD_PROFILE = 'changePasswordProfile'
export const CONFIRM_REGISTER = 'confirmRegister'
export const INFO_ENGINE = 'InfoEngine'
export const CARS = 'cars'
export const NEW_CAR = 'newCar'
export const SEARCH = 'search'
export const TICKETS = 'tickets'
export const PROFILE = 'profile'
export const SETTINGS = 'settings'
export const LOCATION = 'Location'
export const LOCATION_TRIP = 'LocationTrip'
export const PERIODIC_SERVICE = 'periodicService'
export const REPORT_ENGINE = 'reportEngine'
export const REGISTER_DEVICE = 'RegisterDevice'
export const ERROR_ENGINE = 'errorEngine'
export const STATUS_DEVICE = 'statusDevice'
export const HISTORY_ERRORS = 'historyErrors'
export const TRIPS_CAR = 'tripsCar'
export const PATHS_TRAVELED = 'pathsTraveled'
export const CHART_ENGINE = 'chartEngine'
export const CHART_INFO_ENGINE = 'chartInfoEngine'
export const SECURITY = 'security'
export const DEVICES = 'devices'
export const DEVICES_LIST = 'devicesList'
export const STATISTICS_CAR = 'StatisticsCar'
export const THEME_DARK_MODE = 'dark'
export const THEME_LIGHT_MODE = 'lightssssss'
export const APP_PERSIAN_LANGUAGE = 'fa'
export const APP_ENGLISH_LANGUAGE = 'en'
export const BASE_URL = 'https://gateway.lookcar.net'
